import * as PropTypes from "prop-types";

import { ControlReference } from "../../../Engine/Core/ControlDispatcher/ControlReference";
import { Step } from "../../FormParts/Tour/TourTypes";

export const tourStepsContextTypes = {
    addTourStep: PropTypes.func,
    removeTourStep: PropTypes.func,
    getTourSteps: PropTypes.func,
};

export interface TourStepsContext {
    addTourStep: (step: Step, control?: ControlReference) => void;
    removeTourStep: (control: ControlReference) => void;
    getTourSteps: () => Step[];
}
